var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex flex-column content-container overflow-hidden"},[(_vm.$route.meta.hideHeader !== true)?_c('menu-container'):_vm._e(),_c('div',{staticClass:"w-100 header-padding-top d-flex flex-column content-container overflow-hidden"},[_c('router-view')],1),(_vm.$route.meta.hideFooter !== true)?_c('site-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }